<template>
    <div>
        <div class="row h1 page-header">
            Your Orders
        </div>

        <member-orders-list ref="ordersList"></member-orders-list>
    </div>
</template>

<script>
    export default {
    }
</script>
